import { render } from "./DonorAdd.vue?vue&type=template&id=70b4115a"
import script from "./DonorAdd.vue?vue&type=script&lang=js"
export * from "./DonorAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__